module.exports = {"title":"고고밴 개인정보 정책","legal_headline":"고고밴코리아 개인정보취급방침","meta":{"keywords":"고고밴, 개인정보, 정보보호정책","description":"고고밴 개인정보 취급방침"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/kr/setting/legal/locale.json
// module id = 677
// module chunks = 0 1 2 3 4 5